import { render, staticRenderFns } from "./tree_item.vue?vue&type=template&id=2bfe03ee&"
import script from "./tree_item.vue?vue&type=script&lang=js&"
export * from "./tree_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports